/* global SmartOrderRefillSettings */
/**
 *  Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein.
 */

const sorHelpers = require('../sorHelpers/sorHelpers');

const linkModalYes = function (url, e) {
  if (!e.detail || e.detail === 1) {
    $.ajax({
      type: 'GET',
      url: url,
      success: function (response) {
        if (response.success) {
          if (response.toastMessage) {
            try {
              sessionStorage.setItem('sorToastMessage', response.toastMessage);
            } catch (error) {
              window.location.href = SmartOrderRefillSettings.Urls.manageOrders;
            }
          }
          window.location.href = SmartOrderRefillSettings.Urls.manageOrders;
        } else if (response.message) {
          sorHelpers.sorModal.initWarningModal(response.message);
        } else {
          sorHelpers.sorModal.initErrorModal(SmartOrderRefillSettings.Resources.SOR_UNEXPECTED_ERROR, true);
        }
      },
      error: function (err) {
        if (err.responseJSON && err.responseJSON.redirectURL) {
          window.location.href = err.responseJSON.redirectURL;
        } else {
          sorHelpers.sorModal.initErrorModal(SmartOrderRefillSettings.Resources.SOR_UNEXPECTED_ERROR, true);
        }
      }
    });
  }
};

const initLinkModal = function () {
  $(document)
    .off('click', '.sorshowmodal')
    .on('click', '.sorshowmodal', function (e) {
      e.preventDefault();
      const url = $(this).attr('data-link');
      const title = $(this).attr('data-title');
      const content = $(this).attr('data-content');
      const yes = $(this).attr('data-yes');
      const no = $(this).attr('data-no');
      const $container = sorHelpers.sorModal.createContainer('#link-model');
      const options = {
        autoOpen: true,
        modal: true,
        title: title,
        width: '25rem',
        buttons: {}
      };

      if (yes) {
        options.buttons[yes] = linkModalYes.bind($container, url);
      }
      if (no) {
        options.buttons[no] = sorHelpers.sorModal.closeModal;
      }
      $container.html('<h3 class="text-center">' + content + '</h3>');

      sorHelpers.sorModal.createModal($container, options);
    });
};

module.exports = {
  initLinkModal: initLinkModal
};
